module.exports = "/fonts/vendor/material-icons/iconmaterial-icons.woff?3e1afe59fa075c9e04c436606b77f640";